import { TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING } from 'helper/constants';
import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

const CheckboxList = ({
  LIST = TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING,
  selectedTabs,
  handleCheckboxChange,
  className = 'left-position',
}) => {
  return (
    <div
      className={`check-tab d-inline-flex bg-check-row align-items-center ${className}`}
    >
      {Object.entries(LIST).map(([key, tab]) => (
        <FormGroup
          key={tab}
          check
          className="bg-check me-1 d-inline-flex align-items-center mb-0"
        >
          <Label className="font-inter fw-medium" check>
            <Input
              type="checkbox"
              name={tab}
              checked={selectedTabs[tab]}
              onChange={handleCheckboxChange}
            />
            {key.charAt(0) + key.slice(1).toLowerCase()}
          </Label>
        </FormGroup>
      ))}
    </div>
  );
};

export default CheckboxList;
